import React, { useEffect } from 'react';
import { Modal, Form, Input, App } from 'antd';
import { Area } from '../../../types/tables';

interface AreaFormModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: { name: string; description?: string }) => Promise<void>;
  area?: Area;
  loading?: boolean;
}

const AreaFormModal: React.FC<AreaFormModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  area,
  loading = false,
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const isEditing = !!area;

  useEffect(() => {
    if (visible) {
      if (isEditing && area) {
        form.setFieldsValue({
          name: area.name,
          description: area.description,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, isEditing, area, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await onSubmit(values);
      form.resetFields();
      message.success(isEditing ? 'Área actualizada exitosamente' : 'Área creada exitosamente');
    } catch (error) {
      console.error('Error al enviar formulario:', error);
    }
  };

  return (
    <Modal
      title={isEditing ? 'Editar Área' : 'Nueva Área'}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="name"
          label="Nombre del Área"
          rules={[
            { required: true, message: 'El nombre del área es requerido' },
            { max: 100, message: 'El nombre no puede exceder 100 caracteres' },
          ]}
        >
          <Input placeholder="Ej: Salón Principal, Terraza, VIP" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Descripción (opcional)"
          rules={[
            { max: 500, message: 'La descripción no puede exceder 500 caracteres' },
          ]}
        >
          <Input.TextArea
            placeholder="Descripción del área..."
            rows={3}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AreaFormModal;